import { getToken, getUserId, getUserRole } from "../../utilities/authHelper";
import Single_Dashboard_Image from "../../../assets/Single_Dashboard.png";
import Dashboards_Image from "../../../assets/Dashboards_Image.png";
import ProductDashboard from "../ProductDashboard/ProductDashboard";
import DocAssistant from "../DocAssistant/DocAssistant";
import AdminPanel from "../AdminPanel/AdminPanel";
import Home from "../Home/Home";
const tabConfig = [
  {
    name: "Home",
    subTabs: [],
    icon: "fas fa-home fa-lg",
    roles: ["USER", "ADMIN"],
    path: "/home",
    component: <Home />,
  },

  {
    name: "Admin Panel",
    subTabs: [],
    icon: "fas fa-laptop fa-lg",
    roles: ["ADMIN"],
    path: "/admin",
    component: <AdminPanel />,
  },
  {
    name: "Report Reader",
    subTabs: [
      {
        name: "IMF",
        path: "/report-reader?document_type=IMF",
        icon: "fas fa-file",
        roles: ["USER", "ADMIN"],
      },
    ],
    icon: "fas fa-book-open-reader fa-xl",
    roles: ["USER", "ADMIN"],
    path: "/report-reader",
    component: <DocAssistant />,
  },
];

export const createTabs = async (setTabs) => {
  const userRole = getUserRole();
  const tabs = tabConfig.filter((tab) => tab.roles.includes(userRole));
  await FetchUserDashboard(setTabs, tabs);
};

export const FetchUserDashboard = async (setTabs, tabs) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/auth/get_user_dashboard/?user_id=${getUserId()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    const user_dashboard = data.results.dashboard_details.map((x) => {
      const name = x.dashboard_name;
      const dashboardName = x.data_reference;
      const s3_bucket_name = x.s3_bucket_name;
      const s3_prefix = x.s3_prefix;
      const default_start_date =
        x.details_object !== null && x.details_object["default_start_date"];
      const default_end_date =
        x.details_object !== null && x.details_object["default_end_date"];

      return {
        name: name,
        dashboardName: dashboardName,
        s3_bucket_name: s3_bucket_name,
        s3_prefix: s3_prefix,
        icon: "fa-solid fa-chart-simple p-2 ",
        image: Single_Dashboard_Image,
        path: `/dashboard?dashboard_name=${dashboardName}`,
        default_start_date: default_start_date,
        default_end_date: default_end_date,
      };
    });
    if (user_dashboard.length !== 0) {
      setTabs(() => {
        return [
          ...tabs,
          {
            name: "Dashboard",
            subTabs: user_dashboard,
            icon: "fa-chart-pie fa-xl",
            image: Dashboards_Image,
            path: "/dashboard",
            component: <ProductDashboard subTabs={user_dashboard} />,
          },
        ];
      });
    } else {
      return setTabs(() => {
        return [...tabs];
      });
    }
  } catch (error) {
    console.log(error);
  }
};
